export const FINANCIAL_STATUS_UI = {
  paid: "Paid",
  unpaid: "Unpaid",
};

export const ORDER_STATUS_UI = {
  order_placed: "Order Placed",
  processing: "Processing",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
  returned: "Returned",
};

export const ORDER_STATUS = {
  orderPlaced: "order_placed",
  processing: "processing",
  shipped: "shipped",
  delivered: "delivered",
  cancelled: "cancelled",
  returned: "returned",
};

export const PAYMENT_STATUS = {
  paid: "paid",
  unpaid: "unpaid",
};

export const PAYMENT_FAILED_MESSAGE = {
  failure: "Payment Failed",
  cancel: "Payment Failed Due To Cancellation",
  payment_cancelled: "Payment Failed Due To Cancellation",
  duplicate_transaction: "Payment Failed Due To Duplicate Transaction",
  insufficient_balance: "Payment Failed Due To Insufficient Balance",
  payment_failed: "Payment Failed",
};
